<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Tabela de Frete</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermission('tabelafrete.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="fa fa-repeat"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onAprova(null, false)"
                      v-b-tooltip
                      title="Aprovar Registros"
                      v-if="getPermission('tabelafrete.aprovar')"
                      ><i class="fa fa-check"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onCancela(null, false)"
                      v-b-tooltip
                      title="Cancelar Registros"
                      v-if="getPermission('tabelafrete.cancelar')"
                      ><i class="fa fa-times"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImport()"
                      v-b-tooltip
                      title="Importar Tabela de Frete"
                      v-if="getPermissionFw('tabelafrete.importar')"
                      ><i class="fa fa-code step-xml-nfe"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="fa fa-television"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="fa fa-window-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>

                  <vuetable
                    ref="vuetable"
                    api-url="/api/tabelafrete"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="tabfre_id"
                    pagination-path=""
                    detail-row-component="tabelafrete-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <!-- <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermission('tabelafrete.update')"
                          ><i class="fa fa-edit"></i
                        ></a> -->
                        <a
                          @click="onEdit(props.rowData, props.rowIndex, 2)"
                          v-b-tooltip
                          title="Adicionar Rota"
                          v-if="getPermission('tabelafrete.rota.store')"
                          ><i class="fa fa-road"></i
                        ></a>
                        <a
                            @click="onAddTransp(props.rowData, props.rowIndex)"
                            v-b-tooltip
                            title="Adicionar Transportador"
                            v-if="getPermission('tabelafrete.transportador.store')"
                        ><i class="fa fa-truck"></i
                        ></a>
                        <a
                          @click="onCancela(props.rowData, false)"
                          v-b-tooltip
                          title="Cancelar Vigência(s)"
                          v-if="getPermission('tabelafrete.cancelar')"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          @click="onAprova(props.rowData, false)"
                          v-b-tooltip
                          title="Aprovar Vigência(s)"
                          v-if="getPermission('tabelafrete.aprovar')"
                          ><i class="fa fa-check"></i
                        ></a>
                        <span v-if="getPermissionFw('tabelafrete.status')">
                            <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                            <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                        </span>
                        <a
                          @click="onExport(props.rowData)"
                          v-b-tooltip
                          title="Exportar para csv"
                          ><i class="fa fa-sign-out"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                    <template slot="tp_tabela" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.tp_tabela.valor == 1"
                        >{{ props.rowData.tp_tabela.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.tp_tabela.valor == 2"
                        >{{ props.rowData.tp_tabela.descr }}</span
                      >
                    </template>
                    <template slot="tp_receita_despesa" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.tp_receita_despesa.valor == 1"
                        >{{ props.rowData.tp_receita_despesa.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.tp_receita_despesa.valor == 2"
                        >{{ props.rowData.tp_receita_despesa.descr }}</span
                      >
                    </template>
                    <template slot="tp_calc" slot-scope="props">
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.tp_calculo.valor == 1"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-primary"
                        v-if="props.rowData.tp_calculo.valor == 2"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.tp_calculo.valor == 3"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.tp_calculo.valor == 4"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.tp_calculo.valor == 5"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.tp_calculo.valor == 6"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.tp_calculo.valor == 7"
                        >{{ props.rowData.tp_calculo.descr }}</span
                      >
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="fornecedor" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.tabela_frete_transportador.length > 0 &&
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_fisica !== null
                        "
                      >PF /
                        {{ props.rowData.tabela_frete_transportador[0].pessoa.pessoa_fisica.nome }}
                        -
                        {{
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_fisica.cpf
                        }}</span
                      >
                      <span
                          v-if="
                          props.rowData.tabela_frete_transportador.length > 0 &&
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica !==
                            null
                        "
                      >PJ /
                        {{
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica
                              .razao_social
                        }}
                        CNPJ:
                        {{
                          onFormataCnpj(
                              props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica
                                  .cnpj_base,
                              props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica
                                  .cnpj_filial,
                              props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica
                                  .cnpj_digito
                          )
                        }}
                        IE:
                        {{
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_juridica
                              .inscricao_estadual
                        }}</span
                      >
                      <span
                          v-if="
                          props.rowData.tabela_frete_transportador.length > 0 &&
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_exterior !==
                            null
                        "
                      >PE /
                        {{
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_exterior.nome
                        }}
                        -
                        {{
                          props.rowData.tabela_frete_transportador[0].pessoa.pessoa_exterior.cd
                        }}</span
                      >
                      <span v-if="props.rowData.tabela_frete_transportador.length > 1"> <strong> + {{props.rowData.tabela_frete_transportador.length - 1}}</strong></span>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TabelaFreteForm
        ref="tabelafreteform"
        :metodo="onFilterReset"
        :tabela="'tabela_frete'"
        :rota="'tabela_frete'"
        :modal_acao="'u'"
      />
      <TabelaFreteExportar ref="tabelafreteexportar" :metodo="onFilterReset" />
      <TabelaFreteImportarForm ref="tabelafreteimportarform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import TabelaFreteFilterBar from "./TabelaFreteFilterBar";
import TabelaFreteDetalhes from "./TabelaFreteDetalhes";
import TabelaFreteForm from "./TabelaFreteForm";
import TabelaFreteExportar from "./TabelaFreteExportar";
import TabelaFreteImportarForm from "./TabelaFreteImportarForm";

import moment from "moment";

Vue.component("tabelafrete-detalhes", TabelaFreteDetalhes);
export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    TabelaFreteForm,
    TabelaFreteExportar,
    TabelaFreteImportarForm,
    "vuetable-filterbar": TabelaFreteFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      isFullscreen: false,
      optionsTpTabela: [],
      optionsStatusVigencia: [],
      optionsReceitaDespesa: [],
      optionsRegiao: [],
      optionsMunicipio: [],
      optionsParamTipoRodado: [],
      optionsParamTipoCarga: [],
      helpForm: new Form({
        statusRecord: [],
        params: [],
        search: "",
      }),
      form_vig: new Form({
        vig: [],
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
        },
        {
          name: "descr",
          title: "Descrição",
        },
        {
          name: "__slot:tp_receita_despesa",
          title: "Tipo",
        },
        {
          name: "__slot:tp_tabela",
          title: "Tipo Tabela",
        },
        {
          name: "__slot:tp_calc",
          title: "Tipo Cálculo",
        },
        {
          name: "__slot:fornecedor",
          title: "Fornecedor"
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onImport(data) {
      this.$refs.tabelafreteimportarform.errors_array = [];
      this.$refs.tabelafreteimportarform.showModal = true;
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        descr: data_filter.descr,
        fornecedor: data_filter.fornecedor,
        pessoa: data_filter.pessoa.value,
        dt_inicio: data_filter.dt_inicio,
        dt_fim: data_filter.dt_fim,
        status: data_filter.status.value,
        tp_tabela: data_filter.tp_tabela.value,
        receita_despesa: data_filter.receita_despesa.value,
        municipio_origem: data_filter.municipio_origem.value,
        municipio_destino: data_filter.municipio_destino.value,
        regiao_origem: data_filter.regiao_origem.value,
        regiao_destino: data_filter.regiao_destino.value,
        tp_rodado: data_filter.tp_rodado.value,
        carga: data_filter.carga.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.tabfre_id);
      }
    },
    onCreate() {
      this.$refs.tabelafreteform.onCreate();
    },
    onExport(data) {
      this.$refs.tabelafreteexportar.onCreate(data);
    },
    onEdit(data, index) {
      this.$refs.tabelafreteform.onEdit(data, index);
    },
    onAddTransp(data) {
      this.$refs.tabelafreteform.onEditTransp(data);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/tabelafrete/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.tp_tabela.forEach((obj) => {
            this.optionsTpTabela.push({ label: obj.descr, value: obj.valor });
          });
          response.tp_receita_despesa.forEach((obj) => {
            this.optionsReceitaDespesa.push({ label: obj.descr, value: obj.valor });
          });
          response.status_vigencia.forEach((obj) => {
            this.optionsStatusVigencia.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.regiao.forEach((obj) => {
            this.optionsRegiao.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.regiao_id,
            });
          });
          response.municipio.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome + " - " + obj.uf.cd,
              value: obj.municipio_id,
            });
          });
          response.param_tipo_rodado.forEach((obj) => {
            this.optionsParamTipoRodado.push({
              label: obj.descr,
              value: obj.partiprod_id,
            });
          });
          response.param_tipo_carga.forEach((obj) => {
            this.optionsParamTipoCarga.push({
              label: obj.descr,
              value: obj.partipcar_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onAprova(data) {
      this.form_vig.reset();
      let form = this.form_vig;
      var vm = this;

      if (data !== null) {
        var vig = data.tabfre_id;
      }

      const onConfirmUnitWrapper = () => {
        confirmPresenca(vm, vig);
      };

      let confirmPresenca = function (vm, vig) {
        vm.form_vig.vig = [];
        if (vig !== undefined) {
          vm.form_vig.vig.push({ id: vig });
        }
        vm.$refs.vuetable.selectedTo.forEach((obj) => {
          vm.form_vig.vig.push({
            id: obj,
          });
        });
        vm.form_vig
          .post("/api/tabelafrete/store/aprovacaolote")
          .then((response) => {
            new ReturnApi(response, vm);
            vm.$refs.vuetable.selectedTo = [];
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };
      let obj = {
        title: "Você deseja aprovar todas as vigências dessa tabela ?",
        message: 'Vigências com status "Pendente" serão aprovadas',
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    onCancela(data) {
      this.form_vig.reset();
      let form = this.form_vig;
      var vm = this;
      if (data !== null) {
        var vig = data.tabfre_id;
      }

      const onConfirmUnitWrapper = () => {
        confirmPresenca(vm, vig);
      };

      let confirmPresenca = function (vm, vig) {
        vm.form_vig.vig = [];
        if (vig !== undefined) {
          vm.form_vig.vig.push({ id: vig });
        }
        vm.$refs.vuetable.selectedTo.forEach((obj) => {
          vm.form_vig.vig.push({
            id: obj,
          });
        });
        vm.form_vig
          .post("/api/tabelafrete/store/cancelamentolote")
          .then((response) => {
            new ReturnApi(response, vm);
            vm.$refs.vuetable.selectedTo = [];
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };
      let obj = {
        title: "Você deseja cancelar todas as vigências dessa tabela ?",
        message:
          'Vigências com status "Pendente" e "Aprovada" serão canceladas',
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.tabfre_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({
            id: obj,
            status: action,
          });
        });
      }

      this.helpForm
        .post("/api/tabelafrete/status")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.tabfre_id);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
